import { Schema as S } from "effect";

import { defineApi, staticApis } from "../client";
import { ChatHistoryMessage } from "../schemas/ai";

/** Non-streaming chat. `/chat/stream` is a Subscription in U8, not a Command (KTD5). */
export const sendChatMessage = defineApi("SendChatMessage", {
	args: { message: S.String, messages: S.Array(ChatHistoryMessage) },
	response: S.Unknown,
	request: ({ message, messages }) => ({
		method: "POST",
		path: "/chat",
		body: { message, messages },
	}),
});

/** Whether this circle lets AI process its data (Settings); on until turned off. */
export const AiPreferences = S.Struct({ enabled: S.Boolean });
export type AiPreferences = typeof AiPreferences.Type;

export const { getAiPreferences } = staticApis({
	getAiPreferences: ["GET", "/ai/preferences", AiPreferences],
});

export const setAiPreferences = defineApi("SetAiPreferences", {
	args: { enabled: S.Boolean },
	response: AiPreferences,
	request: (body) => ({ method: "PUT", path: "/ai/preferences", body }),
});
